import React, {useState, useEffect} from "react";
import TournamentSelectionItem from "./TournamentSelectionItem";
import DoublesInvitationPanel from "./DoublesInvitationPanel";
import {isUserAdmin} from "../../utils/userUtils";
import useApiStable from "../../utils/useApiStable";

const TournamentSelectionSection = ({
	tournaments,
	selectedTournamentId,
	isExpanded,
	onSelectTournament,
	onResetFilter,
	onClearTournamentSelection,
	user,
	myOverview,
	myOverviewLoading,
	registrationLoading,
	onRegister,
	onUnregister,
	onInviteByEmail,
}) => {
	const admin = isUserAdmin(user);
	const selectedTournament = selectedTournamentId
		? tournaments.find((t) => t.id === selectedTournamentId)
		: null;

	const handleDeselect = () => {
		if (onClearTournamentSelection) {
			onClearTournamentSelection();
		} else {
			onSelectTournament(null);
		}
		onResetFilter();
	};

	if (selectedTournament) {
		return (
			<div className="groupphase-section" style={{paddingBottom: 0}}>
			<h1
					style={{margin: 0, cursor: "pointer", userSelect: "none", color: "#1976d2"}}
					onClick={handleDeselect}
					title="Turnier abwählen"
				>
					Turnier – <span style={{color: "#1976d2"}}>{selectedTournament.name}</span>
				</h1>
			</div>
		);
	}

	return (
		<div className="groupphase-section">
			<h2>Turnier wählen</h2>
			<div style={{display: "flex", flexDirection: "column", gap: 8, marginBottom: 12}}>
				{tournaments.length === 0 ? (
					<p style={{color: "#666", fontStyle: "italic"}}>Keine Turniere verfügbar</p>
				) : (
					<div className="tournament-expanded-list">
						{tournaments.map((tournament) => (
							<TournamentSelectionItem
								key={tournament.id}
								tournament={tournament}
								isActive={false}
								isAdmin={admin}
								onToggle={() => {
									onSelectTournament(tournament.id);
									onResetFilter();
								}}
							/>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

const RegistrationPanel = ({
	tournament,
	myOverview,
	myOverviewLoading,
	registrationLoading,
	onRegister,
	onUnregister,
	onInviteByEmail,
}) => {
	if (myOverviewLoading) {
		return <div style={{color: "#888", fontSize: 13}}>Lade Anmeldestatus...</div>;
	}

	const isRegistrationOpen = myOverview?.registrationOpen ?? tournament.registrationOpen;
	const isRegistered = myOverview?.registered ?? tournament.registered;
	const isDoubles = myOverview != null
		? !myOverview.selfRegistrationSupported
		: tournament.teamSize > 1;

	if (!isRegistrationOpen) {
		return null;
	}

	if (isRegistered) {
		return (
			<div onClick={(e) => e.stopPropagation()}>
				{isDoubles && (
					<DoublesInvitationPanel
						myOverview={myOverview}
						onInviteByEmail={onInviteByEmail}
					/>
				)}
				<button
					onClick={onUnregister}
					disabled={registrationLoading}
					style={{marginTop: 8, padding: "4px 12px", fontSize: 13, cursor: "pointer"}}
				>
					{registrationLoading ? "..." : "Abmelden"}
				</button>
			</div>
		);
	}

	return (
		<div onClick={(e) => e.stopPropagation()}>
			<button
				onClick={onRegister}
				disabled={registrationLoading}
				style={{marginTop: 4, padding: "4px 12px", fontSize: 13, cursor: "pointer"}}
			>
				{registrationLoading ? "..." : "Anmelden"}
			</button>
		</div>
	);
};

const TournamentParticipantList = ({tournamentId, teamSize}) => {
	const api = useApiStable();
	const [teams, setTeams] = useState(null);

	useEffect(() => {
		setTeams(null);
		api.get(`/tournaments/${tournamentId}/teams`)
			.then(setTeams)
			.catch(() => setTeams([]));
	}, [api, tournamentId]); // eslint-disable-line

	if (teams === null) {
		return <div style={{fontSize: 12, color: "#888", marginBottom: 8}}>Lade Anmeldungen...</div>;
	}

	const isIncomplete = (team) => teamSize > 1 && (team.players?.length ?? 0) < teamSize;
	const incompleteCount = teams.filter(isIncomplete).length;

	return (
		<div style={{marginBottom: 8}}>
			<div style={{fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4}}>
				Angemeldet ({teams.length}{incompleteCount > 0 && `, ${incompleteCount} unvollständig`}):
			</div>
			{teams.length === 0 ? (
				<div style={{fontSize: 12, color: "#999", fontStyle: "italic"}}>Noch keine Anmeldungen.</div>
			) : (
				<div>
					{teams.map(team => {
						const incomplete = isIncomplete(team);
						const color = incomplete ? "#e65100" : "#2e7d32";
						const displayName = team.displayName || team.name || (team.players?.[0]?.name ?? "Unbekannt");
						return (
							<div key={team.id} style={{display: "flex", alignItems: "center", gap: 4, fontSize: 12, paddingBottom: 2}}>
								<span style={{color, marginRight: 2}}>•</span>
								<span style={{color}}>{displayName}</span>
								{incomplete && (
									<span style={{color: "#e65100", fontSize: 11, fontStyle: "italic"}}>(unvollständig)</span>
								)}
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default TournamentSelectionSection;
